// src/index.ts
import { dynamicComponent } from "@lb-lib/dynamic-component";
var Unibar = dynamicComponent(async () => (await import("./unibar-DOXOPWDN.js")).Unibar);
export {
  Unibar
};
//# sourceMappingURL=index.js.map